import { render, staticRenderFns } from "./TheAlreadyOpentab.vue?vue&type=template&id=0b8bd7c9"
import script from "./TheAlreadyOpentab.vue?vue&type=script&lang=js"
export * from "./TheAlreadyOpentab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports